<template>
    <el-drawer
        title="添加知识点"
        :visible.sync="drawer"
        :modal="true"
        :wrapperClosable="false"
        size="600px"
        @close="closeDrawer"
        :modal-append-to-body="false"
        :direction="direction">

        <!-- title -->
        <div class="drawer_form">
            
            <el-form :model="form" status-icon :rules="rules" ref="form" label-width="120px" class="demo-ruleForm">
                
                <div class="form-body">
                    <overlay-scrollbars style="width: 100%;height: 100%;" class="el-fade-in">
                        <el-form-item label="资源" prop="resourceId">
                            <el-select v-model="form.resourceId" class="w-full" placeholder="请选择资源" filterable>
                                <el-option
                                    v-for="item in resourceList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="知识点类型" prop="keyPointType">
                            <el-radio-group v-model="form.keyPointType" @change="onKeyPointTypeChange">
                                <el-radio :label="1">文字知识点</el-radio>
                                <el-radio :label="2">课程知识点</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item v-if="form.keyPointType === 1" label="知识点" prop="keyPoint">
                            <el-input type="text" v-model="form.keyPoint" autocomplete="off" placeholder="请输入知识点"></el-input>
                        </el-form-item>
                        <el-form-item v-if="form.keyPointType === 2" label="课程" prop="courseId">
                            <el-select v-model="form.courseId" class="w-full" placeholder="请选择课程" filterable @change="onCourseChange">
                                <el-option
                                    v-for="item in courseList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item v-if="form.keyPointType === 2" label="知识点" prop="keyPoint">
                            <el-cascader
                                v-model="selectedKnowledgePath"
                                :options="chapterKnowledgeTree"
                                :props="cascaderProps"
                                placeholder="请选择章-节-知识点"
                                clearable
                                :show-all-levels="true"
                                style="width: 100%;"
                                @change="onKnowledgeCascaderChange"
                            />
                        </el-form-item>
                        <el-form-item label="摘要" prop="summary">
                            <el-input type="textarea" rows="4" v-model="form.summary" autocomplete="off" placeholder="请输入摘要"></el-input>
                        </el-form-item>
                        <!-- 文档页码范围：仅Word/Excel/PPT显示 -->
                        <el-form-item v-if="showPageRange" label="起始页码" prop="startPage">
                            <el-input-number v-model="form.startPage" :min="1" :max="9999" controls-position="right"></el-input-number>
                        </el-form-item>
                        <el-form-item v-if="showPageRange" label="结束页码" prop="endPage">
                            <el-input-number v-model="form.endPage" :min="1" :max="9999" controls-position="right"></el-input-number>
                        </el-form-item>
                        <!-- 视频时间范围：仅视频显示 -->
                        <el-form-item v-if="showVideoRange" label="起始时间(秒)" prop="videoStartTime">
                            <el-input-number v-model="form.videoStartTime" :min="0" :max="999999" controls-position="right"></el-input-number>
                        </el-form-item>
                        <el-form-item v-if="showVideoRange" label="结束时间(秒)" prop="videoEndTime">
                            <el-input-number v-model="form.videoEndTime" :min="0" :max="999999" controls-position="right"></el-input-number>
                        </el-form-item>
                    </overlay-scrollbars>
                </div>

                <div class="form-foot d-flex a-center j-center">
                    <el-button @click="onSubmit" class="common-button">添加</el-button>
                </div>
            </el-form>
        </div>

    </el-drawer>
    
</template>

<script>
import {create} from '@/request/api/keypoint.js'
import {lists as getResourceList} from '@/request/api/source.js'
import {all as getCourseList} from '@/request/api/course.js'
import {knowledgeWithChapter} from '@/request/api/knowledge_graph.js'
export default {
    data(){
        return {
            drawer: true,
            direction: 'rtl',
            loading:false,
            resourceList: [],
            courseList: [],
            chapterKnowledgeTree: [],
            selectedKnowledgePath: [],
            selectedResourceType: null, // 当前选中资源的类型
            cascaderProps: {
                emitPath: false,
                label: 'name',
                value: 'id',
            },
            form:{
                resourceId:'',
                keyPointType: 1,
                keyPoint:'',
                courseId:'',
                summary:'',
                startPage:null,
                endPage:null,
                videoStartTime:null,
                videoEndTime:null
            },
            rules:{
                resourceId:[
                    { required: true, message: '请选择资源', trigger: 'change' },
                ],
                keyPointType:[
                    { required: true, message: '请选择知识点类型', trigger: 'change' },
                ],
                keyPoint:[
                    { required: true, message: '请输入或选择知识点', trigger: ['blur', 'change'] },
                ],
                courseId:[
                    { required: true, message: '请选择课程', trigger: 'change' },
                ]
            }
        }
    },
    computed:{
        // 是否显示文档页码范围（Word=3, Excel=4, PPT=5）
        showPageRange(){
            return [3, 4, 5].includes(this.selectedResourceType)
        },
        // 是否显示视频时间范围（视频=7）
        showVideoRange(){
            return this.selectedResourceType === 7
        }
    },
    watch:{
        'form.resourceId'(newVal){
            if(newVal){
                const resource = this.resourceList.find(item => item.id === newVal)
                this.selectedResourceType = resource ? resource.type : null
            }else{
                this.selectedResourceType = null
            }
        }
    },
    created(){
        this.loadResourceList()
        this.loadCourseList()
    },
    methods:{
        loadResourceList(){
            getResourceList({page:1,size:1000}).then(res=>{
                this.resourceList = res.data.list || []
            })
        },
        loadCourseList(){
            getCourseList({}).then(res=>{
                this.courseList = res.data || []
            })
        },
        onKeyPointTypeChange(val){
            this.form.keyPoint = ''
            this.form.courseId = ''
            this.selectedKnowledgePath = []
            this.chapterKnowledgeTree = []
        },
        onCourseChange(courseId){
            this.form.keyPoint = ''
            this.selectedKnowledgePath = []
            this.chapterKnowledgeTree = []
            if(!courseId) return
            knowledgeWithChapter({ courseId: courseId }).then(res => {
                if(res.code == 0 && res.data){
                    this.chapterKnowledgeTree = this.transformStructure(res.data)
                }
            })
        },
        transformStructure(data){
            return (data || []).map(function(chapter){
                var chapterNode = {
                    id: 'chapter_' + chapter.id,
                    name: chapter.name,
                    children: []
                }
                var sections = chapter.chapters || chapter.children || []
                sections.forEach(function(section){
                    var sectionNode = {
                        id: 'section_' + section.id,
                        name: section.name,
                        children: []
                    }
                    var knowledges = section.knowledges || []
                    knowledges.forEach(function(k){
                        sectionNode.children.push({ id: k.id, name: k.name })
                    })
                    if(sectionNode.children.length){
                        chapterNode.children.push(sectionNode)
                    }
                })
                var chapterKnowledges = chapter.knowledges || []
                chapterKnowledges.forEach(function(k){
                    chapterNode.children.push({ id: k.id, name: k.name })
                })
                return chapterNode
            })
        },
        onKnowledgeCascaderChange(val){
            this.form.keyPoint = val || ''
        },
        onSubmit(){
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    this.req()
                } else {
                    return false;
                }
            });
        },
        req(){
            create(this.form).then(res=>{
                if(res.code!=0) return this.$notify({title: '失败',message:res.msg,type: 'error'});
                this.$notify({title: '成功',message: "SUCCESS",type: 'success'});
                this.$router.go(-1)
            }) 
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        closeDrawer(){
            this.$router.go(-1)
        }
    }
}
</script>

<style lang="less" scoped>
.drawer_form {
    width: 96%;
    margin: auto;
    .drawer_form_title {
        color: #17233d;
        font-size: 22px;
        font-weight: 400;
        text-align: center;
        line-height: 48px;
        margin-bottom: 20px;
    }

    .drawer_line {
        margin-bottom: 30px;
        .drawer_line_text {
            width: 120px;
            margin-right: 20px;
            text-align: right;
            color: #515a6e;
        }    
    }
}
.form-items {
    background-color:#f5f6fb;padding:15px 10px;height:500px;
}

/deep/ .form-items .el-form-item ,/deep/ .form-items .el-form-item .el-form-item__content{
    width: 100%;
}
</style>
